import React from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '../../config/routes';
import { Terminal, Briefcase, Layers, Code, GraduationCap, FileText, User } from 'lucide-react';

const Navbar = () => {
  const navItems = [
    { name: 'Profile', path: ROUTES.HOME, icon: <User size={18} /> },
    { name: 'Experience', path: ROUTES.EXPERIENCE, icon: <Briefcase size={18} /> },
    { name: 'Projects', path: ROUTES.PROJECTS, icon: <Layers size={18} /> },
    { name: 'Skills', path: ROUTES.SKILLS, icon: <Code size={18} /> },
    { name: 'Education', path: ROUTES.EDUCATION, icon: <GraduationCap size={18} /> },
    { name: 'Resume', path: ROUTES.RESUME, icon: <FileText size={18} /> },
    { name: 'Cover Letter', path: ROUTES.COVER_LETTER, icon: <FileText size={18} /> },
  ];

  return (
    <nav className="sticky top-0 z-50 w-full border-b border-dark-border bg-dark-bg/80 backdrop-blur-md">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <div className="flex items-center space-x-2 text-accent-green font-mono">
          <Terminal size={24} />
          <span className="font-bold text-lg hidden sm:block">sakthi_dev_</span>
        </div>
        
        <div className="flex space-x-1 sm:space-x-4 overflow-x-auto no-scrollbar py-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex items-center space-x-1.5 px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-dark-card text-accent-green border border-dark-border'
                    : 'text-slate-400 hover:text-slate-200 hover:bg-dark-card/50'
                }`
              }
            >
              {item.icon}
              <span className="hidden md:block">{item.name}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
